import { render, staticRenderFns } from "./CatelogItem.vue?vue&type=template&id=bc28b638&scoped=true&"
import script from "./CatelogItem.vue?vue&type=script&lang=js&"
export * from "./CatelogItem.vue?vue&type=script&lang=js&"
import style0 from "./CatelogItem.vue?vue&type=style&index=0&id=bc28b638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc28b638",
  null
  
)

export default component.exports